"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const l=require("react"),o=(e,t=null,i=0)=>l.useCallback((...u)=>{typeof e=="function"&&requestAnimationFrame(()=>setTimeout(()=>e(...u),i))},[...t?[...t]:[e],i]);exports.useYieldCallback=o;
//# sourceMappingURL=use-yield-callback.cjs.map
